export const env = {
  apiUrl:
    import.meta.env.VITE_API_URL ||
    (typeof window === "undefined" ? "" : window.location.origin),
  appUrl: import.meta.env.VITE_APP_URL || "https://app.lekkerladen.com",
  firebaseApiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? "",
  firebaseAuthDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? "",
};
